/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class CertExamCourseCat extends Sv {
    constructor() {
        super();
        this.baseUrl += '/certExamCourseCat';
    }

    data({ certExamCourseId, courseCatName, currentPage, pageSize } = {}) {
        return super.get('/data', {
            certExamCourseId,
            courseCatName,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, certExamCourseId, courseCatName, orderNum } = {}) {
        return super.post('/save', {
            id,
            certExamCourseId,
            courseCatName,
            orderNum,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }
}

export default new CertExamCourseCat();
export { CertExamCourseCat };
